import React,{useState,useEffect} from 'react';
import {BrowserRouter as Router,Routes,Route,useSearchParams} from 'react-router-dom';
import {HelmetProvider} from 'react-helmet-async';
import LandingPage from './pages/LandingPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Imprint from './pages/Imprint';
import BlogIndex from './pages/BlogIndex';
import BlogPost from './pages/BlogPost';
import AboutPage from './pages/AboutPage';
import TopNav from './components/TopNav';

/**
 * LanguageManager component handles the logic for syncing the application
 * state with the URL's lang parameter. This must be inside the Router.
 */ 
function LanguageManager({lang,setLang,children}) {
  const [searchParams]=useSearchParams();
  useEffect(()=> {
    const langParam=searchParams.get('lang');
    if (langParam==='en' || langParam==='es') {
      if (langParam !==lang) {
        setLang(langParam);
      }
    }
  },[searchParams,lang,setLang]);
  return <>{children}</>;
}

export default function App() {
  // Global language state - Default to Spanish per project requirements 
  const [lang,setLang]=useState('es');
  return (
    <HelmetProvider>
      <Router>
        <LanguageManager lang={lang} setLang={setLang}>
          <div className="min-h-screen bg-slate-950 text-slate-200">
            <TopNav lang={lang} setLang={setLang} />
            <Routes>
              <Route path="/" element={<LandingPage lang={lang} />} />
              <Route path="/about" element={<AboutPage lang={lang} />} />
              <Route path="/blog" element={<BlogIndex lang={lang} />} />
              <Route path="/blog/:slug" element={<BlogPost lang={lang} />} />
              <Route path="/privacy" element={<PrivacyPolicy lang={lang} />} />
              <Route path="/imprint" element={<Imprint lang={lang} />} />
            </Routes>
          </div>
        </LanguageManager>
      </Router>
    </HelmetProvider>
  );
}